import { FormGroup } from "@angular/forms";
var PottingInstructionsFormComponent = /** @class */ (function () {
    function PottingInstructionsFormComponent() {
    }
    Object.defineProperty(PottingInstructionsFormComponent.prototype, "pottingInstructions", {
        get: function () {
            return this.treatment.get("pottingInstructions");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PottingInstructionsFormComponent.prototype, "potType", {
        get: function () {
            return this.pottingInstructions.value.potType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PottingInstructionsFormComponent.prototype, "substrate", {
        get: function () {
            return this.pottingInstructions.value.substrate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PottingInstructionsFormComponent.prototype, "irrigation", {
        get: function () {
            return this.pottingInstructions.value.irrigation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PottingInstructionsFormComponent.prototype, "fertigation", {
        get: function () {
            return this.pottingInstructions.value.fertigation;
        },
        enumerable: true,
        configurable: true
    });
    PottingInstructionsFormComponent.prototype.copyValueFrom = function (copyArgs) {
        this.pottingInstructions.patchValue(copyArgs);
        this.pottingInstructions.updateValueAndValidity();
    };
    return PottingInstructionsFormComponent;
}());
export { PottingInstructionsFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/potting-instructions/potting-instructions-form/potting-instructions-form.component.ts.pre-build-optimizer.js